import React, {Fragment} from 'react';

const easyQuiz = {
    "quizTitle": "Trail Cam Quiz: Easy",
    "questions": [
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question1.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Black bear",
                "Common wombat",
                "Raccoon",
                "White-tailed deer"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question2.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American beaver",
                "Muskrat",
                "Porcupine",
                "Woodchuck"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question3.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question4.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Red squirrel",
                "Southern flying squirrel"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question5.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Crow",
                "Black Vulture",
                "Turkey Vulture",
                "Northern Raven"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question6.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question7.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question8.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Robin",
                "Hermit Thrush",
                "Mourning Dove",
                "Wood Thrush"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question9.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Black bear",
                "Common wombat",
                "Raccoon",
                "White-tailed deer"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question10.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Bobcat",
                "Domestic cat",
                "Lynx",
                "Serval"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question11.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Coyote",
                "Domestic dog",
                "Gray fox",
                "Red fox"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question12.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Flying squirrel",
                "Least chipmunk",
                "Red squirrel"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question13.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Flying squirrel",
                "Least chipmunk",
                "Red squirrel"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question14.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Raccoon",
                "Striped skunk",
                "Virginia opossum",
                "Woodchuck"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question15.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American beaver",
                "Muskrat",
                "Porcupine",
                "Woodchuck"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question16.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question17.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question18.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Elk",
                "Moose",
                "Mule deer",
                "White-tailed deer"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question19.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Elk",
                "Moose",
                "Mule deer",
                "White-tailed deer"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/easy/question20.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Elk",
                "Moose",
                "Mule deer",
                "White-tailed deer"
            ],
            "correctAnswer": "4"
        },
    ]
}

export default easyQuiz;


// WEBPACK FOOTER //
// ./src/quiz/easyQuiz.js